import React from 'react';
import { Link as GastbyLink } from '@reach/router';

const Link = (props) => {
  return <GastbyLink {...props} />;
};

export default Link;
